import BracIcon from './BracIcom';
import SavingsIcon from './SavingsIcon';
import ArongFullLogo from './ArongFullLogo';

export const CustomIcon = {
  bracIcon: <BracIcon />,
  savingsIcon: <SavingsIcon />,
  arongFullLogo: <ArongFullLogo />,
};
